module.exports = "https://s91588.cdn.ngenix.net/news-frontend/_next/static/images/advices-1a7e8114a1e2832fc656f830bbc84309.jpg";